export default "__VITE_ASSET__6a69faa3__"